import {eventChannel} from 'redux-saga';
import {select, take, put, call, fork, takeEvery} from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';
import * as actions from '../actions';

//Services
import {openConnection, getSocket} from "../../services/websocket";

import { PAYMENT_STATUS } from '../../const/payment/PAYMENT_STATUS';

function createSocketChannel() {
    const socket = getSocket();

    return eventChannel(emitter => {
        socket.on('connect', () => emitter({type: 'CONNECTED'}));
        socket.on('FINISH_PAYMENT', payload => emitter({type: 'FINISH_PAYMENT', payload: JSON.parse(payload)}));

        return () => socket.close();
    });
}

function* handleMessage({type, payload}) {
    switch (type) {
        case 'CONNECTED':
            yield* authenticate();
            break;
        case 'FINISH_PAYMENT':
            const popUpWindow = yield select(state => payload.type === 'booking' ? state.payment.popUpWindow : state.bundles.popUpWindow);
            if (payload.status !== PAYMENT_STATUS.PENDING && !!popUpWindow && !popUpWindow.closed) {
                popUpWindow.close();
            }

            switch (payload.type) {
                case 'booking':
                    const bookingID = yield select(state => state.payment.bookingID);
                    if (bookingID !== payload.id) {
                        return;
                    }

                    const bookingStatus = payload.status === PAYMENT_STATUS.PENDING
                        ? PAYMENT_STATUS.ERROR
                        : payload.status

                    yield put(actions.updatePaymentStatus(bookingStatus));

                    if (bookingStatus === PAYMENT_STATUS.OK) {
                        const first = yield select(state => state.events.first);

                        yield put(actions.getReservations());
                        yield put(actions.getEvents(first, 6));
                    }
                    break;
                case 'bundle':
                    const clientBundleID = yield select(state => state.bundles.clientBundleID);
                    if (clientBundleID !== payload.id) {
                        return;
                    }

                    const bundleStatus = payload.status === PAYMENT_STATUS.PENDING
                        ? PAYMENT_STATUS.ERROR
                        : payload.status

                    yield put(actions.updateBundlePaymentStatus(bundleStatus));

                    if (bundleStatus === PAYMENT_STATUS.OK) {
                        yield put(actions.getReservations());
                        yield put(actions.getBundlesAll());
                    }
                    break;
                case 'subscription':
                    const { clientSubscriptionID, paymentStatus } = yield select(state => state.subscriptions);
                    if (clientSubscriptionID !== payload.id || paymentStatus !== PAYMENT_STATUS.PENDING) {
                        yield put(actions.getSubscriptionsList())
                        return;
                    }

                    yield put(actions.setPaymentStatus({ status: payload.status }));
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }
}

export function* connectToWebSocket() {
    const wsBaseURL = yield select(state => state.widget.wsBaseURL);

    openConnection(`${wsBaseURL}/client`);
    const channel = yield call(createSocketChannel);

    while (true) {
        try {
            const action = yield take(channel);
            yield fork(handleMessage, action)
        } catch (err) {
            console.error(err);
        }
    }
}

export function* authenticate() {
    const socket = getSocket();

    try {
        const email = yield select(state => state.profile.profile && state.profile.profile.email);
        const companyAPIKey = yield select(state => state.auth.companyKey);

        if (!companyAPIKey) {
            return;
        }

        socket.emit('authenticate', JSON.stringify({email, company_api_key: companyAPIKey}));
    } catch (err) {
        console.error(err);
    }
}

export const watchWebSocket = [
    takeEvery(actionTypes.CONNECT_TO_WEBSOCKET, connectToWebSocket),
    takeEvery(actionTypes.AUTHENTICATE, authenticate)
];